import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from './pages/ProductDetail';
import { ProductProvider } from './contexts/ProductContext';
import ScrollToTop from './components/Shared/ScrollToTop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {AuthProvider } from './contexts/AuthContext';
import Checkout from './components/checkout/Checkout';
// import PrivateRoute from './pages/PrivateRoute';
import LoginPage from './pages/LoginPage';
import UserProfile from './pages/UserProfile';
import UserDetailsForm from './components/checkout/UserDetailsForm';
// import AuthRoutes from './routes/AuthRoutes';
// import UnAuthRoutes from './routes/UnAuthRoutes';

function App() {

  return (

    <Router>
      <AuthProvider>
      <ProductProvider>
      <ScrollToTop />
      <ToastContainer/>
        <Routes>
        {/* {AuthRoutes} */}
          {/* {UnAuthRoutes} */}
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/profile" element={<UserProfile />} />
          <Route path="/checkout" element={<Checkout />} />
          {/* <Route path="/checkout/addressDetails" element={<UserDetailsForm />} /> */}
          {/* <Route path="/checkout" element={<Checkout />} />
          {/* <PrivateRoute path="/checkout" element={<Checkout />} /> Use PrivateRoute for the Checkout route */}
          
        </Routes>
      </ProductProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
